import type { ReactNode, ReactElement } from 'react';

import { Typography } from '@mui/material';
import SearchNotFound from 'src/components/SearchNotFound';
import ChatNavItem from './ChatNavItem';
import { useTranslation } from 'react-i18next';

export interface ChatNavSearchResultsProps {
  searchResults?: any[];
  onSelectConversation?: (...args: any[]) => any;
  searchConversations?: string;
  [key: string]: any;
}

// ----------------------------------------------------------------------

export default function ChatNavSearchResults({
  searchConversations,
  searchResults,
  onSelectConversation,
}: ChatNavSearchResultsProps) {
  const { t } = useTranslation('translation');
  const isNotFound = !searchResults.length && !!searchConversations;

  return (
    <>
      <Typography
        paragraph
        variant="h6"
        sx={{
          px: 2.5,
        }}
      >
        {t('chat.conversations')}
      </Typography>

      {isNotFound ? (
        <SearchNotFound
          searchQuery={searchConversations}
          sx={{
            p: 3,
            mx: 'auto',
            width: `calc(100% - 40px)`,
            bgcolor: 'background.neutral',
          }}
        />
      ) : (
        <>
          {searchResults.map(
            (result) =>
              result && (
                <ChatNavItem
                  key={result.id}
                  conversation={result}
                  openNav={true}
                  isSelected={false}
                  onSelect={() => onSelectConversation(result)}
                />
              )
          )}
        </>
      )}
    </>
  );
}
